import type { Messages } from './messages';

/**
 * Copy for `src/app/sign-in/`. Owned by that page's author, and by nobody else.
 *
 * Every key starts with `signIn.` — the compiler refuses anything else, so
 * this file cannot collide with another page's. Shared words (save, cancel,
 * retry, statuses, role names) are already in `common.ts` and
 * `vocabulary.ts`; use those rather than restating them here.
 *
 * One rule runs through the refusals: nothing here may say whether an address
 * belongs to an operator. The API answers an unknown address, a wrong password
 * and a suspended account identically, and so does this copy.
 */
export const signIn = {
  'signIn.title': 'تسجيل الدخول',
  'signIn.lead': 'ادخل بحساب المشغّل الذي أنشأه لك مشرف المنصّة.',
  'signIn.form': 'نموذج تسجيل الدخول',
  'signIn.email': 'البريد الإلكتروني',
  'signIn.emailPlaceholder': 'name@example.com',
  'signIn.password': 'كلمة المرور',
  'signIn.submit': 'تسجيل الدخول',
  'signIn.submitting': 'جارٍ التحقق…',
  'signIn.submitWait': 'متاح بعد {seconds} ث',
  'signIn.capsLock': 'مفتاح الأحرف الكبيرة (Caps Lock) مفعّل.',
  'signIn.next': 'سجّل الدخول للمتابعة إلى الصفحة التي طلبتها.',

  'signIn.emailRequired': 'أدخل البريد الإلكتروني.',
  'signIn.emailInvalid': 'هذا لا يبدو عنوان بريد إلكتروني. مثال: name@example.com',
  'signIn.passwordRequired': 'أدخل كلمة المرور.',

  'signIn.refusedTitle': 'تعذّر تسجيل الدخول',
  'signIn.refusedBody':
    'البريد الإلكتروني أو كلمة المرور غير صحيحة، أو أن الحساب غير مفعّل. تحقّق منهما وأعد المحاولة؛ وإن تكرّر ذلك فاطلب من مشرف المنصّة مراجعة حسابك.',
  'signIn.limitedTitle': 'محاولات كثيرة في وقت قصير',
  'signIn.limitedBody': 'أُوقفت المحاولات مؤقتًا لحماية الحساب. أعد المحاولة بعد {seconds} ثانية.',
  'signIn.limitedBodyShort': 'أُوقفت المحاولات مؤقتًا لحماية الحساب. أعد المحاولة بعد قليل.',
  'signIn.unreachableTitle': 'الخادم غير متاح',
  'signIn.serverTitle': 'تعذّر على الخادم إتمام الدخول',
  'signIn.invalidTitle': 'راجع الحقول المُعلَّمة',
  'signIn.otherTitle': 'تعذّر تسجيل الدخول',

  'signIn.help':
    'لا يوجد تسجيل ذاتي: حسابات المشغّلين يُنشئها مشرف المنصّة، وهو من يعيد تعيين كلمة المرور عند نسيانها.',
} as const satisfies Messages<'signIn'>;
